import axiosInstance from "../../helpers/api";

export const getUserData = () => {
    return axiosInstance.get(`/userInfo`);
};